module.exports = __webpack_public_path__ + "img/8.d5252e39.jpg";